import { render, staticRenderFns } from "./Home.bundle-pool-bulk.vue?vue&type=template&id=2b88b70d&scoped=true&"
import script from "./Home.bundle-pool-bulk.vue?vue&type=script&lang=js&"
export * from "./Home.bundle-pool-bulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88b70d",
  null
  
)

export default component.exports